import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import Skeleton from '@mui/material/Skeleton';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { connectorSchema } from '../utils';
import { useTranslation } from 'react-i18next';
import { ControlledTextField } from 'components/shared/ControlledFields';
import { isNil } from 'ramda';
import { LoadingButton } from '@mui/lab';
import Box from '@mui/material/Box';
import { useEditConfigs } from '../useEditConfigs';
import { editConnectorConfig } from 'RestAPIs/admin';

export const AFASConnectorTab = ({ AFASConnectors, isFetching }) => {
  const { t } = useTranslation('common');

  const { mutateAsync: save, isLoading } = useEditConfigs({
    request: editConnectorConfig,
    invalidateQueryKey: ['connectors-config'],
    message: null
  });

  const methods = useForm({
    defaultValues: connectorSchema.cast(AFASConnectors),
    resolver: yupResolver(connectorSchema)
  });

  const { handleSubmit } = methods;

  const onSubmit = async (data) => {
    await save(data);
  };

  return !isFetching && !isNil(AFASConnectors) ? (
    <Box sx={{ maxWidth: 450 }}>
      <MultiStepForm methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <MultiStepForm.Section title={t('AFASConnectors')}>
          <ControlledTextField
            control={methods.control}
            name="benefits"
            label={t('ConnectorTab.benefits')}
          />
          <ControlledTextField
            control={methods.control}
            name="addresschanges"
            label={t('ConnectorTab.addresschanges')}
          />
          <ControlledTextField
            control={methods.control}
            name="absences"
            label={t('ConnectorTab.absences')}
          />
          <ControlledTextField
            control={methods.control}
            name="salaries"
            label={t('ConnectorTab.salaries')}
          />
          <ControlledTextField
            control={methods.control}
            name="travelarrangements"
            label={t('ConnectorTab.travelarrangements')}
          />
          <ControlledTextField
            control={methods.control}
            name="employees"
            label={t('ConnectorTab.employees')}
          />
          <ControlledTextField
            control={methods.control}
            name="hourmanagement"
            label={t('ConnectorTab.hourmanagement')}
          />
        </MultiStepForm.Section>
        <MultiStepForm.Actions>
          <LoadingButton
            loading={isLoading}
            type="submit"
            variant="contained"
            color="primary"
          >
            {t('save')}
          </LoadingButton>
        </MultiStepForm.Actions>
      </MultiStepForm>
    </Box>
  ) : (
    <Skeleton />
  );
};
